module.exports = __webpack_public_path__ + "static/img/bdcd7977c52deea761efa41e07ab33e2d1964a36.88a3abb8.jpg";